import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'

export const RedirectFromCatchAll = () => {
  const navigate = useNavigate()

  useEffect(() => {
    void navigate({ to: '/list', replace: true })
  }, [navigate])

  return null
}
